// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { rentsModel } from '@/firebase/firebase-config'

export const GetFutureRentTerms = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        future_rent_terms: []

    }),

    /*
	**  Methods
    */
    
    methods: {

        getFutureRentTermsHandler: function(property_id) {

            try {

                // Get the doc
                rentsModel.where('relationships.property', '==', property_id).where('meta.deleted_at', '==', null).where('attributes.term', '==', 'future').get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Set the doc prop
                    **  @prop_location: @here
                    */

                    snapshot.forEach(doc => {

                        this.future_rent_terms.push(doc.data());

                    });

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get Future Rent Terms from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: 'oj9GbgWwYcy3dJ1Abmkq',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Getting Future Rent Terms.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'OGwGdHemlsQ0i7q61i0z',
                    error: e
                });

            }

        }

    }

}